// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"daf44c69","386":"f02c2120","498":"fc1cdbae","701":"9aa0b0ed","908":"82337df2"}[chunkId] + ".chunk.js";
};